{
  "version": 1,
  "asset_id": "dbf15942-fc28-44fa-bbbc-f3694371e3b6",
  "project_id": "ca7587fa-3476-4974-b258-69992cc9166e",
  "url": "/__l5e/assets-v1/dbf15942-fc28-44fa-bbbc-f3694371e3b6/monteurs.png",
  "r2_key": "a/v1/ca7587fa-3476-4974-b258-69992cc9166e/dbf15942-fc28-44fa-bbbc-f3694371e3b6/monteurs.png",
  "original_filename": "monteurs.png",
  "size": 211255,
  "content_type": "image/png",
  "created_at": "2026-10-19T17:44:50Z"
}
